import './CommunicationsTab.scss';
import React, { useContext, useState, Component, useEffect } from 'react';
import UserService from '../../Store/UserService';
import { LocationServiceContext } from '../../Store/LocationsService/LocationServiceProvider';
import SessionContext from '../../SessionContext';

const CommunicationsTab = (props) => {
  const session = useContext(SessionContext);
  const [state, setstate] = useState({
    redirectToLogin: false,
    redirectToCoverSearch: false,
  });
  const { setAllLocations, setSelectedLocationKeys, setGCoverKey,setAllowedCoverKeysBookings,setAllowedCoverKeysRegForms } = useContext(
    LocationServiceContext
  );

  useEffect(async () => {
    await UserService.authenticateSession(props, session, setSelectedLocationKeys, setAllLocations, setGCoverKey, setstate, state, setAllowedCoverKeysBookings, setAllowedCoverKeysRegForms);
  }, []);

  return (
    <>
      <div className='page-cont'>
        <div className='center'>
          <h1>Welcome to your<br/>Patient Engagement<br/>platform<br/>Communications</h1>
        </div>
      </div>
    </>
  );
};
export default CommunicationsTab;
